import React from "react";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import OrgStatsReport from "../../Reports/OrgStatsReport";

export default function OrgStatsPage(props) {
  return (
    <div>
      <Breadcrumb
        pageName={I18n.t("admin.org_stats")}
        category={I18n.t("admin.reports")}
      />
      <OrgStatsReport
        login_stats_endpoint={props.login_stats_endpoint}
        login_daily_endpoint={props.login_daily_endpoint}
        learning_stats_endpoint={props.learning_stats_endpoint}
        assessment_well_being_endpoint={props.assessment_well_being_endpoint}
        assessment_abc_endpoint={props.assessment_abc_endpoint}
        assessment_stats_endpoint={props.assessment_stats_endpoint}
        export_datatable_endpoint={props.export_datatable_endpoint}
        export_endpoint={props.export_endpoint}
        report={props.report}
      />
    </div>
  );
}
